import { render, staticRenderFns } from "./companyResources.vue?vue&type=template&id=0f08780d"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f08780d')) {
      api.createRecord('0f08780d', component.options)
    } else {
      api.reload('0f08780d', component.options)
    }
    module.hot.accept("./companyResources.vue?vue&type=template&id=0f08780d", function () {
      api.rerender('0f08780d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/companyResources.vue"
export default component.exports